import axios from 'axios';
import { corporateClubExtractMock } from 'test/mock/corporateClubExtractMock';

import { GetCorporateClubExtract } from './types';

export const getCorporateClubExtract = async (apiDomain: string) => {
  const smilesGetTierUrl = `${apiDomain}/corporate-club/v1/extract`;
  const JWTToken = localStorage.getItem('session-token');
  const vbzDebug = localStorage.getItem('vbzDebug');

  if (vbzDebug) {
    return corporateClubExtractMock;
  }

  return axios
    .get<GetCorporateClubExtract>(smilesGetTierUrl, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data)
    .catch((error) => error);
};

export const getIsClub = async (apiDomain: string) => {
  const JWTToken = localStorage.getItem('session-token');
  const url = `${apiDomain}/corporate-club/v1/active-flag`;
  const vbzDebug = localStorage.getItem('vbzDebug');

  if (vbzDebug) {
    return true;
  }

  const result = await axios.get<{
    isCorporateClubActive: boolean;
  }>(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${JWTToken}`,
    },
  });

  return result.data.isCorporateClubActive;
};
